import axiosOriginal, { AxiosAdapter, AxiosInstance } from "axios";

const clientName = process.env.REACT_APP_CLIENT_NAME || "";

const timeout = parseInt(process.env.REACT_APP_REQUEST_TIMEOUT || "60000", 10);

const axios: AxiosInstance = axiosOriginal.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  timeout,
});

// Audit trail header
axios.interceptors.request.use((req) => {
  req.headers["X-Client-Application"] = clientName;
  return req;
});

export const toggleCustomAxiosAdapter = (adapter: AxiosAdapter): void => {
  axios.defaults.adapter = adapter;
};

export default axios;
